module.exports = __webpack_public_path__ + "img/edit-dropdown-icon.69b2b7cc.svg";